export default "__VITE_ASSET__DQearlkf__"